import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import {
  FilterCondition,
  FilterDTO,
  FilterOperator,
  PagedResultDTOOfParkerDTO,
  PagedResultDTOOfParkerExtractReportDTO,
  ParkerClient,
  ParkerExtractReportClient,
  ParkerExtractReportParameterDTO,
  ParkerExtractReportSummaryDTO,
  SavedReportFileDTO,
  SortDirection
} from '../../../../base/models/models.swagger.generated';
import { catchError } from 'rxjs/operators';
import { ErrorType } from '../../../../core/routing/error-types';
import { ClientService } from '../../../../base/services/client/client.service';
import { ToastService } from '../../../../base/services/toast.service';
import { SaveOptions } from '../../reports-footer/save-options';
import { ShowInactiveService } from '../../../../base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from '../../../../base/shared/syncfusion/adaptor-service.interface';

@Injectable()
export class ParkerExtractReportService extends ShowInactiveService implements IAdaptorService {
  public reportParameters: ParkerExtractReportParameterDTO = null;

  constructor(private parkerClient: ParkerClient,
    private clientService: ClientService,
    private toastService: ToastService,
    private parkerExtractReportClient: ParkerExtractReportClient) {
    super();
  }

  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<PagedResultDTOOfParkerExtractReportDTO> {
    if (!this.reportParameters) {
      return of(new PagedResultDTOOfParkerExtractReportDTO({items: [], totalNumberOfItems: 0}));
    }

    const clientId = !this.clientService.selectedClient ? 0 : this.clientService.selectedClient.id;
    return this.parkerExtractReportClient.searchParkerExtractReportData(clientId, this.reportParameters, skip, take, undefined).pipe(
      catchError((error: any) => {
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
        }
        return throwError(() => error);
      }),
    );
  }

  public addRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public updateRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public deleteRecord(id: number): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public exportReport(parkerExtractReportParameter: ParkerExtractReportParameterDTO, saveOptions: SaveOptions): Observable<SavedReportFileDTO> {
    const clientId = this.clientService.selectedClient ? this.clientService.selectedClient.id : 0;
    return this.parkerExtractReportClient.exportParkerExtractReport(
      clientId,
      saveOptions.exportType,
      saveOptions.saveReport,
      parkerExtractReportParameter
    )
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }

  public getReportSummary(summary: ParkerExtractReportParameterDTO): Observable<ParkerExtractReportSummaryDTO> {
    const clientId = this.clientService.selectedClient ? this.clientService.selectedClient.id : 0;
    return this.parkerExtractReportClient.summarizeParkerExtractReport(clientId, summary)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }

  public searchParkerDropdownValues(searchText: string): Observable<PagedResultDTOOfParkerDTO> {
    const filterDTOs = [];
    filterDTOs.push(new FilterDTO({
      isComplex: true,
      condition: FilterCondition.Or,
      predicates: [
        new FilterDTO({
          isComplex: false,
          field: 'FirstName',
          operator: FilterOperator.Contains,
          value: searchText,
        }),
        new FilterDTO({
          isComplex: false,
          field: 'LastName',
          operator: FilterOperator.Contains,
          value: searchText,
        }),
      ],
    }));

    return this.parkerClient.searchParkers(this.clientService.selectedClient.id, filterDTOs, 0, 9, 'Firstname', SortDirection.Ascending, false, false)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }
}
